<template>
  <form @submit.prevent="handleSubmit">
    <modal-card title="Pin Feed">
      <b-field label="Order">
        <b-input type="number" v-model="form.order"></b-input>
      </b-field>

      <div slot="foot">
        <button type="button" @click="$parent.close()" class="button">
          Cancel
        </button>

        <button
          type="submit"
          class="button is-primary"
          :class="{ 'is-loading': form.processing }"
        >
          Pin Feed
        </button>
      </div>
    </modal-card>
  </form>
</template>

<script>
export default {
  props: ["feedId", "whenPinned"],

  data() {
    return {
      form: new window.Form({
        order: 1
      })
    };
  },

  methods: {
    handleSubmit() {
      this.form
        .post(`/admin/api/pinned-feeds/${this.feedId}`)
        .then(({ message, data }) => {
          this.$buefy.toast.open(message);
          this.$parent.close();
          this.whenPinned(data);
        });
    }
  }
};
</script>
